import React from "react";

export default function ManageJobCardStat({ value, label, onClick, disabled }) {
  return (
    <button
      type="button"
      className={`manage-job-card__footer-action ${
        disabled ? "manage-job-card__footer-action--disabled" : ""
      }`}
      onClick={(event) => {
        event.stopPropagation();
        onClick?.(event);
      }}
      disabled={disabled}
    >
      <span className="manage-job-card__footer-value">{value}</span>
      <span className="manage-job-card__footer-label">{label}</span>
    </button>
  );
}
